// import { isSMKGuide } from './service-utils'

export const analyticsPageView = (pageTitle, pathname, currentRoute) => {
  // console.log('analyticsPageView', pageTitle, pathname)

  const isDevEnv = Boolean(window.location.host.includes('192.168.') || window.location.host.includes('localhost') || window.location.host.includes('firebaseapp'))
  if(isDevEnv) return

  // const TRACKING_ID = isSMKGuide(currentRoute) ? window.GA_TRACKING_ID__SMK_GUIDE : window.GA_TRACKING_ID

  // window.gtag('config', TRACKING_ID, {
  //   'page_title' : pageTitle,
  //   'page_path': pathname
  // })
}

export const analyticsEvent = (category = '', action = '', label = '', value = '') => {
  
  const isDevEnv = Boolean(window.location.host.includes('192.168.') || window.location.host.includes('localhost') || window.location.host.includes('firebaseapp'))
  if(isDevEnv) {
    console.log('analyticsEvent', category, action, label, value)
    return
  }

  // window.gtag('event',
  //   action,
  //   {
  //   'event_category': category,
  //   'event_label': label,
  //   'value': value
  //   })

  /* example:
  gtag('event', 'video_auto_play_start', {
    'event_label': 'My promotional video',
    'event_category': 'video_auto_play',
    'non_interaction': true
  })
  */
}




// WEBPACK FOOTER //
// ./src/services/service-analytics.js